import { Hotel, MapPin, Car, Train, Plane, Ticket } from "lucide-react";

export const TYPE_ICON = {
  alojamiento: Hotel, actividad: MapPin, entradas: Ticket,
  transfer: Car, tren: Train, vuelo: Plane,
};

export const ESTADO_META = {
  pendiente: { label: "Pendiente", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  solicitada: { label: "Solicitada", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  reconfirmado: { label: "Reconfirmado (F)", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const CHANNEL_META = {
  mail: { label: "Mail", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  telefono: { label: "Teléfono", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  whatsapp: { label: "WhatsApp", cls: "bg-green-50 text-green-700 border-green-200" },
  voucher: { label: "Voucher", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  web: { label: "Web", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  otro: { label: "Otro", cls: "bg-muted text-muted-foreground border-border" },
  desconocido: { label: "Sin canal", cls: "bg-muted text-muted-foreground border-border" },
};

export function fmtDayHeader(iso) {
  if (!iso) return "Sin fecha";
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d)) return iso;
  const s = d.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function addDaysISO(iso, n) {
  const [y, m, d] = (iso || todayISO()).split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + n);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
}
